import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35e6dad0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice-table__wrap" }
const _hoisted_2 = { class: "invoice-table" }
const _hoisted_3 = ["id", "onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "targetted"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]

import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { ICompanyInvoice } from "@/models/company-invoice";
import { ICompanySetting } from "@/models/company-setting";
import IconCheck from "@/assets/svgs/icon_check.svg";
import IconCheckGreen from "@/assets/svgs/icon_check_green.svg";
import IconTriangleBottom from "@/assets/svgs/icon_triangle_bottom.svg";
import { ISortDirection } from "@/models/sort-direction";
import ChangeStatusModal from "@/components/common/ChangeStatusModal.vue";

// =========================== Router ===========================
interface IProps {
  isSelectedAll: boolean;
  tableData: ICompanyInvoice[] | ICompanySetting[];
  sortCondition: string;
  sortDirection: ISortDirection;
  changeSortCondition: (sortCondition: string) => void;
}

interface ITableHeader {
  label: string;
  key: string;
  sort_condition: string;
  allRequired?: boolean;
  width?: string;
}

/*
 * allRequired: true => isSelectedAll === true
 * allRequired: false => isSelectedAll === false
 * allRequired: undefined => always true
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'CardInvoiceTable',
  props: {
    isSelectedAll: { type: Boolean },
    tableData: {},
    sortCondition: {},
    sortDirection: {},
    changeSortCondition: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();
const onClickAccountName = (companyId: number) => {
  router.push({ name: "accounting-company-edit", params: { id: companyId } });
};

// =========================== Props ===========================


const state = reactive({
  visibleChangeStatusModal: false,
});

const selectedCompanyInvoice = ref({} as ICompanyInvoice);

const openChangeStatusModal = (companyInvoice: ICompanyInvoice) => {
  selectedCompanyInvoice.value = companyInvoice;
  state.visibleChangeStatusModal = true;
};

const closeChangeStatusModal = () => {
  state.visibleChangeStatusModal = false;
};

const translateStatus = (status: string) => {
  switch (status) {
    case "billed":
      return "freeeに発行済み";
    case "irregular":
      return "取引担当者から\n変更依頼あり";
    case "checking":
      return "取引担当者確認中";
    default:
      return "";
  }
};

const onClickTableHeader = (headerKey: string) => {
  props.changeSortCondition(headerKey);
};

// =========================== Data ===========================
const checkTableHeaderDisplay = (header: ITableHeader) => {
  if (header.allRequired === undefined) {
    return true;
  } else if (header.allRequired === true) {
    return props.isSelectedAll;
  } else {
    return !props.isSelectedAll;
  }
};

const tableHeader: ITableHeader[] = [
  {
    label: "ステータス",
    key: "status",
    sort_condition: "desc",
    allRequired: false,
  },
  {
    label: "請求管理対象",
    key: "invoice_targetted",
    sort_condition: "desc",
    allRequired: true,
  },
  {
    label: "アカウント名",
    key: "company_name",
    sort_condition: "desc",
  },
  {
    label: "プラン",
    key: "contract_plan",
    sort_condition: "desc",
  },
  {
    label: "年次契約数",
    key: "annually_contract_count",
    sort_condition: "desc",
  },
  {
    label: "年次契約\nの期限",
    key: "annually_contract_expired_date",
    sort_condition: "desc",
  },
  {
    label: "年次契約\nの備考",
    key: "annually_contract_memo",
    sort_condition: "desc",
  },
  {
    label: "月次契約数",
    key: "monthly_contract_count",
    sort_condition: "desc",
  },
  {
    label: "月次契約\nの備考",
    key: "monthly_contract_memo",
    sort_condition: "desc",
  },
  {
    label: "請求期日",
    key: "invoice_due_date",
    sort_condition: "desc",
  },
  {
    label: "振込期日",
    key: "transfer_due_date",
    sort_condition: "desc",
  },
  {
    label: "経理担当",
    key: "accounting_operators_company_invoices.name",
    sort_condition: "desc",
  },
  {
    label: "取引担当",
    key: "operators.name",
    sort_condition: "desc",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableHeader, (header) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: header.key
              }, [
                (checkTableHeaderDisplay(header))
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 0,
                      id: header.key,
                      class: _normalizeClass(header.key),
                      onClick: () => onClickTableHeader(header.key)
                    }, [
                      _createTextVNode(_toDisplayString(header.label) + " ", 1),
                      _createVNode(_unref(IconTriangleBottom), { class: "sort-condition-icon" })
                    ], 10, _hoisted_3))
                  : _createCommentVNode("", true)
              ], 64))
            }), 64))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (row) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: row.id
            }, [
              (_ctx.isSelectedAll)
                ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
                    ((row as ICompanySetting).invoice_targetted)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                          _createVNode(_unref(IconCheck)),
                          _createTextVNode(" 対象 ")
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_6, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["status", (row as ICompanyInvoice).status]),
                      onClick: () => openChangeStatusModal(row as ICompanyInvoice)
                    }, [
                      ((row as ICompanyInvoice).status === 'billed')
                        ? (_openBlock(), _createBlock(_unref(IconCheckGreen), { key: 0 }))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(translateStatus((row as ICompanyInvoice).status)), 1)
                    ], 10, _hoisted_7)
                  ])),
              _createElementVNode("td", null, [
                _createElementVNode("span", {
                  class: "account_name_td",
                  onClick: () => onClickAccountName(row.company_id)
                }, _toDisplayString(row.company_name), 9, _hoisted_8)
              ]),
              _createElementVNode("td", null, _toDisplayString(row.labels.contract_plan), 1),
              _createElementVNode("td", null, _toDisplayString(row.annually_contract_count || '-'), 1),
              _createElementVNode("td", null, _toDisplayString(row.annually_contract_expired_date || '-'), 1),
              _createElementVNode("td", null, _toDisplayString(row.annually_contract_memo || '-'), 1),
              _createElementVNode("td", null, _toDisplayString(row.monthly_contract_count || '-'), 1),
              _createElementVNode("td", null, _toDisplayString(row.monthly_contract_memo || '-'), 1),
              _createElementVNode("td", null, _toDisplayString(row.labels.invoice_due_date || '-'), 1),
              _createElementVNode("td", null, _toDisplayString(row.labels.transfer_due_date || '-'), 1),
              _createElementVNode("td", null, _toDisplayString(row.accounting_operator?.name || '-'), 1),
              _createElementVNode("td", null, _toDisplayString(row.cs_operator?.name || '-'), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(ChangeStatusModal, {
      visible: state.visibleChangeStatusModal,
      "company-invoice": selectedCompanyInvoice.value,
      "on-close": closeChangeStatusModal
    }, null, 8, ["visible", "company-invoice"])
  ], 64))
}
}

})